var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video-js',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin vjs-live vjs-liveui",attrs:{"preload":"auto","data-setup":"{\"fluid\": true, \"liveui\": true}"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }